import React, { useEffect, useState } from 'react';
import './Hero.css';
import WaitlistForm from '../../common/WaitlistForm/WaitlistForm';

function Hero() {
  const [isVisible, setIsVisible] = useState(true);
  const [showWaitlist, setShowWaitlist] = useState(false);
  
  useEffect(() => {
    // Remove this useEffect if you want the content to be visible immediately
    setIsVisible(true);
  }, []);

  const openCalendly = () => {
    window.open('https://calendar.app.google/wYBwpPdBAzNo7CCL9', '_blank');
  };

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="gradient-overlay"></div>
        <div className="grid-pattern"></div>
        <div className="animated-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>
      <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
        <div className="hero-text">
          <h1>
            <span className="block">Get your brand mentioned</span> 
            <span className="block">in AI Search</span>
          </h1>
          
          <div className="ai-platforms">
            <div className="platform">
              <div className="platform-icon">
                <img src="/images/chatgpt-logo.png" alt="ChatGPT" />
              </div>
              <span>ChatGPT</span>
            </div>
            <div className="platform">
              <div className="platform-icon">
                <img src="/images/perplexity-logo.png" alt="Perplexity" />
              </div>
              <span>Perplexity</span>
            </div>
            <div className="platform">
              <div className="platform-icon">
                <img src="/images/google-ai-logo.png" alt="Gemini" />
              </div>
              <span>Gemini</span>
            </div>
          </div>
          
          <p className="subtitle">
            Drive qualified traffic as millions of consumers turn to AI for purchase decisions.
          </p>
          
          <div className="cta-container">
            {/* Comment out the original waitlist button */}
            {/* <button 
              onClick={() => setShowWaitlist(true)} 
              className="cta-button"
            >
              Request Early Access
            </button> */}

            {/* Add new Calendly button */}
            <a 
              href="https://calendly.com/ishgun-tryxlr8/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button"
            >
              Book a Demo
            </a>
          </div>
        </div>

        <div className="hero-image">
          <div className="image-container">
            <img src="/images/Page5.png" alt="AI Search Overview" className="overview-img" />
            <div className="image-overlay"></div>
          </div>
        </div>
      </div>

      {showWaitlist && (
        <WaitlistForm onClose={() => setShowWaitlist(false)} />
      )}
    </section>
  );
}

export default Hero;